import { CLUSTERS_VISIBLE_STATUSES } from '../../clusters/clusters.models';

interface QueryParams {
  limit: number;
  sort: string;
  direction: string;
  include?: string;
  exclude?: string;
  q?: string;
  status?: string;
  offset?: number;
  workspace_id?: string;
}

export const QueryParamsJobsList: QueryParams = {
  limit: 20,
  sort: 'created',
  direction: 'desc',
  include: 'owner,package,cluster',
  exclude: 'outputs,variables',
};

export const QueryParamsMembersList: QueryParams = {
  limit: 20,
  sort: 'name',
  direction: 'asc',
};

export const QueryParamsKeysList: QueryParams = {
  limit: 20,
  sort: 'name',
  direction: 'asc',
};

export const QueryParamsHooksList: QueryParams = {
  limit: 20,
  sort: 'name',
  direction: 'asc',
};

export const QueryParamsAccountsList: QueryParams = {
  limit: 20,
  sort: 'name',
  direction: 'asc',
};

export const QueryParamsAccountsMenuList: QueryParams = {
  sort: 'name',
  direction: 'asc',
  offset: 0,
  limit: 100,
};

export const QueryParamsClustersList: QueryParams = {
  limit: 100,
  sort: 'created',
  direction: 'desc',
  include: 'owner',
  status: CLUSTERS_VISIBLE_STATUSES.join(','),
};

export const QueryParamsSchedulesList: QueryParams = {
  limit: 20,
  sort: 'updated',
  direction: 'desc',
  include: 'owner,package,workspace',
};

export const QueryParamsWorkspacesList: QueryParams = {
  limit: 28,
  sort: 'updated',
  direction: 'desc',
  include: 'packages',
};

export const QueryParamsConnectionsList: QueryParams = {
  limit: 20,
  sort: 'updated',
  direction: 'desc',
  include: 'owner',
};

export const QueryParamsPackagesList: QueryParams = {
  limit: 20,
  sort: 'updated',
  direction: 'desc',
  include: 'owner,workspace',
};
